export default __webpack_public_path__ + "v3.410/youtube-icon.png";